// removed by extract-text-webpack-plugin
module.exports = {"root":"Avatar__root__3X8Wx","initials":"Avatar__initials__2F4ZF","avatarImage":"Avatar__avatarImage__1IifJ","mediumAvatar":"Avatar__mediumAvatar__1PolI","largeAvatar":"Avatar__largeAvatar__1oPa0","bannedUserIcon":"Avatar__bannedUserIcon__3PKWd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/Avatar.css
// module id = 1416
// module chunks = 0